import { sendWebsocketMessage } from '../../../../../../App';

export function addPositionBreakPriceFromChart(tradePlanId, price, symbol, quote = null) {
  const msg = {
    messageType: 'updateTradePlan',
    tradePlanId,
    field: 'addBreakPriceFromChart',
    value: {
      price,
      symbol,
      ...(quote?.bid != null ? { bid: quote.bid } : {}),
      ...(quote?.ask != null ? { ask: quote.ask } : {}),
    },
  };
  sendWebsocketMessage(msg);
}
